import PropTypes from 'prop-types';
import React from 'react';
import { Input } from 'antd';
import styled from 'styled-components';

const StyledSearch = styled(Input.Search)`
  ${p => p.inputWidth && `width: ${p.inputWidth};`}
`;

const SearchFilter = ({ label, onSearch, inputWidth, placeholder = '' }) =>
  <>
    {label && <label>{label}</label>}
    <StyledSearch
      placeholder={placeholder}
      inputWidth={inputWidth}
      onSearch={onSearch}
    />
  </>;
SearchFilter.propTypes = {
  label: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  inputWidth: PropTypes.object,
};

export default SearchFilter;
